import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content-index" }
const _hoisted_2 = { class: "content-index__search" }
const _hoisted_3 = { class: "filter__search" }
const _hoisted_4 = { class: "content-index__header" }
const _hoisted_5 = { class: "content-index__list" }
const _hoisted_6 = ["data-nav-anchor", "data-nav-disabled"]
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_content_index_header = _resolveComponent("content-index-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_input, {
          ref: "input",
          label: _ctx.$t('content.index.search.' + _ctx.type),
          name: "filter-search",
          autocomplete: "off",
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          "hide-label": "",
          "hide-mandatory-marker": ""
        }, null, 8 /* PROPS */, ["label", "modelValue"]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "input__button input__button--icon_search" }, null, -1 /* HOISTED */))
      ])
    ]),
    _cache[4] || (_cache[4] = _createTextVNode()),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_content_index_header, {
        "section-id-prefix": `content-index__${_ctx.type}_`
      }, null, 8 /* PROPS */, ["section-id-prefix"])
    ]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listKeys, (letterEntry) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `h${letterEntry}`,
          "data-nav-anchor": letterEntry,
          "data-nav-disabled": !_ctx.listData[letterEntry].length ? 'disabled' : null
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["content-index__head", {'content-index__head--empty': !_ctx.listData[letterEntry].length}])
          }, _toDisplayString(letterEntry), 3 /* TEXT, CLASS */),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("div", {
            class: "content-index__items",
            id: `content-index__${_ctx.type}_${letterEntry}`
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listData[letterEntry], (entry) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(entry.link ? 'a' : 'span'), {
                key: entry.link + '_'+ entry.name,
                href: entry.link,
                class: "content-index__item",
                rel: entry.link ? entry.follow : null
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(entry.name), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "rel"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 8 /* PROPS */, _hoisted_7)
        ], 8 /* PROPS */, _hoisted_6))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}